import React from 'react'
import { resolvePrismicLink } from '../../../utils/prismicLinkResolver'
import usePageContext from '../../../hooks/usePageContext'
import ReasonsWhySection from '../../sections/ReasonsWhySection'
import { ReasonsWhySliceProps } from './types'
import { mapButtonProps } from '../../atoms/Button/utils'

const ReasonsWhySlice: React.FC<ReasonsWhySliceProps> = ({ slice }) => {
  const {
    rw_title,
    rw_is_main_heading,
    rw_specification_title,
    rw_specification_description,
    rw_button_text = '',
    rw_button_type,
    rw_button_is_centered,
    rw_button_caption,
    rw_button_caption_mobile_size,
    rw_button_caption_desktop_size,
    rw_button_link
  } = slice.primary || {}

  const { group } = usePageContext()

  return (
    <ReasonsWhySection
      heading={rw_title?.text}
      isMainHeading={rw_is_main_heading}
      paddingTop={['4rem', '', '']}
      paddingBottom={['5rem', '', '']}
      data={{
        specification: {
          specificationLabel: rw_specification_title,
          specificationInfo: rw_specification_description?.html
        },
        cta: mapButtonProps(
          rw_button_type,
          rw_button_text,
          resolvePrismicLink(rw_button_link, group),
          rw_button_link?.link_type,
          rw_button_caption,
          rw_button_caption_mobile_size,
          rw_button_caption_desktop_size,
          rw_button_is_centered
        ),
        listItems: (slice.items || []).map((item, index) => ({
          key: `${index}`,
          label: item?.rw_reason_label
        }))
      }}
      bgColor="#F8FAFF"
      inner="inners.primary"
    />
  )
}

export default ReasonsWhySlice
